var map = {
	"./game-1/tutorial/elementary.json": 7335,
	"./game-1/tutorial/high.json": 37482,
	"./game-1/tutorial/middle.json": 37743,
	"./game-2/tutorial/elementary.json": 37969,
	"./game-2/tutorial/high.json": 14373,
	"./game-2/tutorial/middle.json": 25084,
	"./game-3/tutorial/elementary.json": 16684,
	"./game-3/tutorial/high.json": 14369,
	"./game-3/tutorial/middle.json": 47092,
	"./game-4/tutorial/elementary.json": 89759,
	"./game-4/tutorial/high.json": 84067,
	"./game-4/tutorial/middle.json": 860,
	"./game-5/tutorial/elementary.json": 13458,
	"./game-5/tutorial/high.json": 65278,
	"./game-5/tutorial/middle.json": 28442,
	"./game-6/tutorial/elementary.json": 75392,
	"./game-6/tutorial/high.json": 52335,
	"./game-6/tutorial/middle.json": 64730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 35393;